<template>
  <div style="width: 100%;height: 100%">
    <Card dis-hover style="min-height: 100%;">
      <Steps :current="stepsNum" size="small">
        <Step title="处方笺"></Step>
        <Step title="医嘱说明"></Step>
        <Step title="饮食原则"></Step>
        <Step title="营养目标"></Step>
        <Step title="饮食食谱"></Step>
        <Step title="其他设置"></Step>
      </Steps>
      <Carousel v-model="stepsNum" arrow="never" dots="none"
                style="padding-top: 40px;overflow-y: auto" :style="{height: $store.state.contentHeith - 175 +'px'}">
        <CarouselItem>
          <Row style="padding: 0 20px" type="flex" justify="center" align="bottom">
            <Col span="24">
            <div style="padding: 10px 0;border-bottom: 1px solid #c3c3c3;border-top: 1px solid #c3c3c3">
              <h2 style="text-align: center;padding-bottom: 10px">处方笺</h2>
              <h3>Rp</h3>
            </div>
            <Card style="margin: 10px 0" :key="item.medicalId" v-for="(item, i) in prescription.content">
              <!--<h3>{{i+1 + '.' + item.medicalName + item.specs}}</h3>-->
              <h3>{{i+1 + '.' + item.medicine.name}}</h3>
              <p v-if="item.num > 0">数量：{{item.num}}盒</p>
              <div style="display: flex;flex-direction: row">
                <p>用法用量：{{item.channel ? item.channel : ''}} </p>
                <p>&nbsp;&nbsp;{{item.once.num ? item.once.num : 0 }}</p>
                <p>{{item.once.type ? item.once.type : '' }}</p>
                <p>&nbsp;&nbsp;{{item.frequency ? item.frequency : ''}} </p>
                <p>&nbsp;&nbsp;使用{{item.dayNum ? item.dayNum : 0}}天 </p>
              </div>
              <!--<p>用法用量：{{item.channel ? item.channel : ''  + ' ' + item.once.num ? item.once.num : 0 + item.once.type ? item.once.type : ''-->
              <!--+ ' ' + item.frequency ? item.frequency : '' + ' 用药' + item.dayNum ? item.dayNum : '' + '天'}}</p>-->
              <p>补充说明：{{item.content}}</p>
              <Row type="flex" justify="end">
                <Button type="success" style="margin: 0 10px" @click.stop="medicineIndex = i, medicineEditModal = true">
                  编辑
                </Button>
                <Button type="error" style="margin: 0 10px" @click.stop="delMedicine(i)">删除</Button>
              </Row>
            </Card>
            <Button type="info" style="margin-top: 10px" long @click.stop="openMedicineModal">+继续添加药品/营养素</Button>
            </Col>
          </Row>
        </CarouselItem>
        <CarouselItem>
          <Row type="flex" style="padding: 0 20px" justify="center">
            <Col span="24">
            <Form label-position="top">
              <FormItem label="医嘱说明：">
                <Input v-model="prescription.advice" type="textarea" :autosize="{minRows:20,maxRows: 20}"
                       placeholder="请输入医嘱说明。。。"/>
              </FormItem>
            </Form>
            </Col>
          </Row>
        </CarouselItem>
        <CarouselItem>
          <Row type="flex" style="padding: 0 20px" justify="center">
            <Col span="24">
            <Form :label-width="100">
              <FormItem label="饮食原则：">
                <Select transfer multiple v-model.sync="prescription.dietGuidelines" placeholder="请选择" @on-change="getFoodsByDietGuidline">
                  <Option v-for="item in dietGuidelinesAllList" :value="item.id" :key="item.id">
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Form>
            <Card style="margin: 10px 0"
                  v-if="prescription.dietGuidelines != null && prescription.dietGuidelines.length > 0 ">
              <p slot="title">设置患者的原则禁食界限：</p>
              <div v-if="prescription.dietGuidelines.indexOf(item.id) !== -1" v-for="item in dietGuidelinesAllList"
                   :key="item.id"
              >
                <div
                  style="display: flex;flex-direction: row"
                >
                  <p style="width: 100px;line-height: 32px;min-width: 100px">{{item.name}}:</p>
                  <Select transfer placeholder="请选择"
                          v-model="prescription.dietGuidelinesDetail[prescription.dietGuidelines.indexOf(item.id)]">
                    <Option v-for="lit in item.detailList" :value="lit.id" :key="lit.id">
                      {{ lit.name }}
                    </Option>
                  </Select>
                </div>
                <card style="margin: 5px ">{{item.description}}</card>
                <!--<p style="width: 250px;line-height: 32px;margin-left: 5px" v-if="prescription.dietGuidelinesDetail[ind] != null">-->
                <!--即{{prescription.dietGuidelinesDetail[ind].name}}及以上不能吃</p>-->
              </div>
            </Card>
            <!--<Collapse v-if="prescription.dietGuidelines.length > 0 " v-model="panelValue">-->
              <!--<Form :label-width="100" style="margin-top: 10px">-->
                <!--<Row>-->
                  <!--<Col span="12">-->
                  <!--<FormItem label="食材：">-->
                    <!--<Input v-model="foodMaterial" placeholder="请输入" clearable prefix="ios-search" @on-enter.stop="getFoodsByDietGuidline"/>-->
                  <!--</FormItem>-->
                  <!--</Col>-->
                  <!--<Col span="12" style="display: flex;flex-direction: row;justify-content: flex-end">-->
                  <!--<Button type="info" icon="ios-search" @click="getFoodsByDietGuidline">查询</Button>-->
                  <!--</Col>-->
                <!--</Row>-->
              <!--</Form>-->
              <!--<Panel>-->
                <!--可食用食材-->
                <!--<p slot="content">-->
                <!--<Table stripe max-height="350" :columns="dietGuidelinesColumns" :data="edibalFoodList"></Table>-->
                <!--</p>-->
              <!--</Panel>-->
              <!--<Panel >-->
                <!--不建议食用食材-->
                <!--<p slot="content">-->
                <!--<Table stripe max-height="350" :columns="dietGuidelinesColumns" :data="inedibleFood"></Table>-->
                <!--</p>-->
              <!--</Panel>-->
            <!--</Collapse>-->
            </Col>
          </Row>
        </CarouselItem>
        <CarouselItem>
              <Row type="flex" style="padding: 0 20px" justify="center" align="bottom">
                  <Col span="24">
                  <Form :label-width="100">
                      <Row>
                          <Col span="10">
                          <FormItem label="患者年龄：">
                              <!--<Select transfer v-model="nutritionalGoalSearch.age" placeholder="请选择">-->
                              <!--<Option :value="nutritionalGoalSearch.age">{{nutritionalGoalSearch.age}}</Option>-->
                              <!--</Select>-->
                              <input v-model="nutritionalGoalSearch.age" placeholder="请输入..." style="width: 100px"/>
                          </FormItem>
                          </Col>
                          <Col span="10">
                          <FormItem label="患者性别：">
                              <Select transfer v-model="nutritionalGoalSearch.sex" placeholder="请选择">
                                  <Option value="0">男性</Option>
                                  <Option value="1">女性</Option>
                              </Select>
                          </FormItem>
                          </Col>
                          <Col span="4">
                          <Button type="info" long @click="findAllNutritionalGoal">查询</Button>
                          </Col>
                      </Row>
                  </Form>
                  <div style="padding-bottom: 20px;">
                      <Card>
                          <p slot="title">营养目标</p>
                          <Table
                                  v-if="nutritionalGoal != null"
                                  stripe
                                  max-height="500"
                                  :columns="nutritionalGoalInfoColumns"
                                  :data="nutritionalGoal.infoList"
                          >
                              <template slot-scope="{ row, index }" slot="value">
                                  <Input v-model="nutritionalGoal.infoList[index].value" style="top: 0;" placeholder="请输入">
                                  <span slot="append">{{row.nutritionType.unit}}</span>
                                  </Input>
                              </template>
                          </Table>
                      </Card>
                  </div>
                  </Col>
              </Row>
          </CarouselItem>
        <CarouselItem>
          <Row type="flex" style="padding: 0 20px" justify="center">
            <Col span="24">

            <Collapse v-if="prescription.dietGuidelines.length > 0 " v-model="panelValue">
              <Form :label-width="100" style="margin-top: 10px">
                <Row>
                  <Col span="12">
                  <FormItem label="食材：">
                    <Input v-model="foodMaterial" placeholder="请输入" clearable prefix="ios-search"/>
                  </FormItem>
                  </Col>
                  <Col span="12" style="display: flex;flex-direction: row;justify-content: flex-end">
                  <Button type="info" icon="ios-search" @click="getUserFoods">查询</Button>
                  </Col>
                </Row>
              </Form>
              <Panel>
                可食用食材
                <p slot="content">
                <Table stripe max-height="350" :columns="dietGuidelinesColumns" :data="edibalFoodList"></Table>
                </p>
              </Panel>
              <Panel >
                不建议食用食材
                <p slot="content">
                <Table stripe max-height="350" :columns="dietGuidelinesColumns" :data="inedibleFood"></Table>
                </p>
              </Panel>
            </Collapse>
            <div style="padding-bottom: 20px;">
              <Card>
                <!--<p slot="title">食谱模板{{$store.state.contentWidth - 700 - 85}}</p>-->
                <p slot="title">食谱</p>
                <p>
                <Table
                  :width="$store.state.contentWidth > 1400 ?$store.state.contentWidth - 700 - 107 : $store.state.contentWidth/2-107"
                  border
                  stripe
                  :columns="columnsAdd"
                  :data="dietPlanitemTable"
                >
                  <template v-for="week in ['sev','one','tow','thr','fou','fiv','six']" slot-scope="{ row, index }"
                            :slot="week">
                    <Form style="margin: 10px 0" v-if="addItemInfo.dietPlan != null && row != null">
                      <Row v-for="(foodMaterial,indes) in addItemInfo.dietPlan[row[week]]" :key="indes">
                        <Col span="12">
                        <FormItem style="margin: 10px 5px">
                          <Select
                            transfer
                            filterable
                            v-model="foodMaterial.foodMaterialId"
                            placeholder="请选择食材"
                          >
                            <Option v-for="item in foodMaterialAllList" :value="item.foodMaterialId" :key="item.foodMaterialId">{{ item.foodMaterialName }}</Option>
                          </Select>
                        </FormItem>
                        </Col>
                        <Col span="6">
                        <FormItem style="margin: 10px 5px">
                          <!--<InputNumber :min="0" v-model="foodMaterial.value"-->
                                       <!--:formatter="value => `${value}克`"-->
                                       <!--placeholder="请输入食材数量"></InputNumber>-->
                          <InputNumber :min="0" v-model="foodMaterial.value"
                                       placeholder="请输入食材数量"></InputNumber>
                        </FormItem>
                        </Col>
                        <Col span="2">
                        <Tooltip transfer placement="top" content="备注" theme="light">
                          <Poptip transfer placement="right">
                            <Button class="my_Button"
                                    style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">
                              <Icon type="md-git-network" size="20"/>
                            </Button>
                            <div class="api" slot="content">
                              <Input type="text" v-model="foodMaterial.remark" placeholder="请输入备注"/>
                            </div>
                          </Poptip>
                        </Tooltip>
                        </Col>
                        <Col span="4">
                        <FormItem style="margin: 10px 5px">
                          <Button @click="removeTemplateInfo(row[week], indes)">删除</Button>
                        </FormItem>
                        </Col>
                      </Row>
                      <Row>
                        <FormItem style="margin: 10px 5px">
                          <Button type="dashed" long @click="addTemplateInfo(row[week])" icon="md-add">添加新的食物</Button>
                        </FormItem>
                      </Row>
                    </Form>
                  </template>
                </Table>
                </p>
              </Card>
            </div>
            </Col>
          </Row>
        </CarouselItem>
        <CarouselItem>
          <Row type="flex" style="padding: 0 20px" justify="center">
            <Col span="24">
            <Card>
              <p slot="title">下次随诊设置</p>
              <Form :label-width="120">
                <FormItem label="是否下次随诊：">
                  <i-switch @on-change="followDiagnose">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="随诊时间：" v-if="prescription.followDiagnose">
                  <DatePicker type="datetime" placeholder="请选择..." style="width: 100%"
                              v-model="prescription.followTime"></DatePicker>
                </FormItem>
                <FormItem label="问卷提醒时间：" v-if="prescription.followDiagnose">
                  <Select v-model="prescription.remindTime">
                    <Option value="1">1天前</Option>
                    <Option value="2">2天前</Option>
                    <Option value="3">3天前</Option>
                    <Option value="5">5天前</Option>
                    <Option value="7">1周前</Option>
                  </Select>
                </FormItem>
              </Form>

            </Card>
            </Col>
          </Row>
        </CarouselItem>
      </Carousel>
      <Row style="padding: 10px 0px">
        <Col span="8" offset="3">
        <Button v-if="stepsNum > 0" type="warning" long @click="prevSteps">上一步</Button>
        </Col>
        <Col span="8" offset="2">
        <Button type="info" long @click="nextSteps">
          <span v-if="stepsNum < 5">下一步</span>
          <span v-else>完成</span>
        </Button>
        <!--<Button v-if="stepsNum == 5" type="info" long @click="nextSteps">完成</Button>-->
        </Col>
      </Row>
    </Card>

    <!--药品-->
    <Modal
      v-if="medicineVo !== null"
      v-model="medicineModal"
      title="调整用法用量"
    >
      <div style="display: flex;">
        <p style="line-height: 32px;width: 100px;text-align: right;padding-right: 12px">选择药品/营养素：</p>
        <Select v-model="medicineVo.medicalName" style="width: 50%" filterable @on-change="medicineChange">
          <Option :value="index" :key="medicine.id" v-for="(medicine, index) in medicineList">{{medicine.name}}</Option>
        </Select>
      </div>
      <Card style="margin: 5px 20px;" v-if="medicineVo.medicine != null">{{medicineVo.medicine.description}}</Card>
      <Form :label-width="100">
        <FormItem style="margin-bottom: 10px" label="单次药量：">
          <Input v-model="medicineVo.once.num" style="width: 50%"/>
          <Input v-model="medicineVo.once.type" placeholder="用药单位" style="width: 50%"/>
          <!--<Select v-model="medicineVo.once.type" style="width: 50%">-->
            <!--<Option value="mg/次">mg/次</Option>-->
          <!--</Select>-->
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="给药频率：">
          <Input v-model="medicineVo.frequency" placeholder="给药频率" style="width: 50%"/>
          <!--<Select v-model="medicineVo.frequency">-->
            <!--<Option value="每日一次">每日一次</Option>-->
            <!--<Option value="每日两次">每日两次</Option>-->
            <!--<Option value="每日三次">每日三次</Option>-->
            <!--<Option value="每日三次">每日四次</Option>-->
          <!--</Select>-->
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="给药途径：">
          <Input v-model="medicineVo.channel" placeholder="给药途径" style="width: 50%"/>
          <!--<Select v-model="medicineVo.channel">-->
            <!--<Option value="口服">口服</Option>-->
            <!--<Option value="外用">外用</Option>-->
          <!--</Select>-->
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="给药天数：">
          <InputNumber v-model="medicineVo.dayNum" :min="0" style="width: 50%"/>
          <span style="padding-left: 20px">天</span>
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="开药数：">
          <InputNumber v-model="medicineVo.num" :min="0" style="width: 50%"/>
          <span style="padding-left: 20px">盒</span>
        </FormItem>
        <div>
          <p style="margin-bottom: 10px">补充说明（选填）</p>
          <Input v-model="medicineVo.content" type="textarea" :autosize="{minRows:3,maxRows: 10}" placeholder="请输入..."/>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click.stop="cancelMedical">取消</Button>
        <Button type="primary" size="large" @click.stop="addMedical">确定</Button>
      </div>
    </Modal>

    <Modal
      v-if="prescription.content[medicineIndex] != null"
      v-model="medicineEditModal"
      title="调整用法用量"
    >
      <h3 style="margin-bottom: 10px;text-align: center">{{prescription.content[medicineIndex].medicine.name}}</h3>
      <Card style="margin: 5px 20px;">{{prescription.content[medicineIndex].medicine.indication}}</Card>
      <Form :label-width="100">
        <FormItem style="margin-bottom: 10px" label="单次药量：">
          <Input v-model="prescription.content[medicineIndex].once.num" style="width: 50%"/>
          <Select v-model="prescription.content[medicineIndex].once.type" style="width: 50%">
            <Option value="mg/次">mg/次</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="给药频率：">
          <Input v-model="prescription.content[medicineIndex].frequency" placeholder="给药频率" style="width: 50%"/>
          <!--<Select v-model="prescription.content[medicineIndex].frequency">-->
            <!--<Option value="每日一次">每日一次</Option>-->
            <!--<Option value="每日两次">每日两次</Option>-->
            <!--<Option value="每日三次">每日三次</Option>-->
            <!--<Option value="每日三次">每日四次</Option>-->
          <!--</Select>-->
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="给药途径：">
          <Input v-model="prescription.content[medicineIndex].channel" placeholder="给药途径" style="width: 50%"/>
          <!--<Select v-model="prescription.content[medicineIndex].channel">-->
            <!--<Option value="口服">口服</Option>-->
            <!--<Option value="外用">外用</Option>-->
          <!--</Select>-->
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="给药天数：">
          <InputNumber v-model="prescription.content[medicineIndex].dayNum" :min="0" style="width: 50%"/>
          <span style="padding-left: 20px">天</span>
        </FormItem>
        <FormItem style="margin-bottom: 10px" label="开药数：">
          <InputNumber v-model="prescription.content[medicineIndex].num" :min="0" style="width: 50%"/>
          <span style="padding-left: 20px">盒</span>
        </FormItem>
        <div>
          <p style="margin-bottom: 10px">补充说明（选填）</p>
          <Input v-model="prescription.content[medicineIndex].content" type="textarea"
                 :autosize="{minRows:3,maxRows: 10}" placeholder="请输入..."/>
        </div>
      </Form>
      <div slot="footer">
        <!--<Button type="text" size="large" @click.stop="medicineModal = false" >取消</Button>-->
        <Button type="primary" size="large" @click.stop="medicineEditModal = false">确定</Button>
      </div>
    </Modal>
    <!--食材详情-->
    <Modal v-model="infoModel" title="食材详情" width="600" @on-cancel="cancelItem">
      <Form :label-width="100">
        <Row v-if="infoItem != null">
          <Col span="12">
          <FormItem label="食材名称：">
            {{infoItem.name}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="食材单位：">
            {{infoItem.unit}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="食材类别：">
            {{infoItem.foodMaterialType.name}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="升糖指数(GI)：">
            {{infoItem.gi}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="血糖负荷(GL)：">
            {{infoItem.gl}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="食材品牌：">
            {{infoItem.brand}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="食材产地：">
            {{infoItem.origin}}
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="食材品种：">
            {{infoItem.variety}}
          </FormItem>
          </Col>
        </Row>
      </Form>
      <Form label-position="top">
        <FormItem label="营养物质：" v-if="infoItem != null">
          <Table stripe max-height="250" :columns="columnsInfo" :data="infoItem.nutritionTypeList"></Table>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
  import Card from "../../../node_modules/iview/src/components/card/card.vue";

  export default {
    components: {Card},
    name: "",
    props: {
      user: {
        type: Object,
        default: null
      },
      caseData: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
          panelValue: [1, 2],
          foodMaterial: '',
          edibalFoodList: [],
          inedibleFood: [],
          infoModel: false,
          infoItem: null,
        stepsNum: 0,
        prescription: {
          dietGuidelines: [],
          dietGuidelinesDetail: [],
          dietPlanId: '',
          nutritionalGoalId: '',
          content: [],
          medicineUsageId: '',
          advice: null,
          followDiagnose: false,
          followTime: null,
          remindTime: '3'
        },
        addItemInfo: {
          dietPlan: null,
        },
        dietGuidelinesAllList: [],//所有原则
        dietGuidelinesColumns: [
          {
            type: 'index',
            width: 80,
            align: 'center',
          },
          {
            title: '食材',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render: (h, params) => {
              return h('span', params.row.name + "(" + params.row.unit + ")")
            }
          },
          {
            title: '原则',
            key: 'dietText',
            align: 'center',
            ellipsis: true,
            tooltip: true,
          },
          {
            title: '备注',
            key: 'dietTextRemark',
            align: 'center',
            ellipsis: true,
            tooltip: true,
          }
        ],//原则表头
        dietPlanAllList: [], //所有食谱
        columnsAdd: [
          {
            title: '时间',
            width: 100,
            key: 'dataTime',
            align: 'center',
            fixed: 'left',
            ellipsis: true,
            tooltip: true,
          },
          {
            title: '周天',
            key: 'age',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'sev',
            width: 450,
          },
          {
            title: '周一',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'one',
            width: 450,
          },
          {
            title: '周二',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'tow',
            width: 450,
          },
          {
            title: '周三',
            key: 'age',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'thr',
            width: 450,
          },
          {
            title: '周四',
            key: 'age',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'fou',
            width: 450,
          },
          {
            title: '周五',
            key: 'age',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'fiv',
            width: 450,
          },
          {
            title: '周六',
            key: 'age',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            slot: 'six',
            width: 450,
          },
        ],//食谱表头
        dietPlanitemTable: [{
          dataTime: '早餐',
          one: '01',
          tow: '11',
          thr: '21',
          fou: '31',
          fiv: '41',
          six: '51',
          sev: '61'
        },
          {dataTime: '午餐', one: '02', tow: '12', thr: '22', fou: '32', fiv: '42', six: '52', sev: '62'},
          {dataTime: '晚餐', one: '03', tow: '13', thr: '23', fou: '33', fiv: '43', six: '53', sev: '63'},
          {dataTime: '加餐', one: '04', tow: '14', thr: '24', fou: '34', fiv: '44', six: '54', sev: '64'}], // 食谱表结构
        foodMaterialAllList: [],//原则对应的食材
        nutritionalGoal: null, //对应的营养目标
        nutritionalGoalSearch: {
          age: this.user.age,
          sex: this.user.sex
        },
        nutritionalGoalInfo: [], //所有营养物质
        nutritionalGoalInfoColumns: [
          {
            type: 'index',
            width: 80,
            align: 'center',
          },
          {
            title: '营养物质',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render: (h, params) => {
              let item = params.row
              return h("span", item.nutritionType.name)
            },
          },
          {
            title: '含量',
            ellipsis: true,
            tooltip: true,
            slot: 'value'
          },
        ],//营养物质表头
          medicineModal: false,
        medicineVo: null,
        medicineEditModal: false,
        doctorAdvice: '',//医嘱
        medicineList: [],
        medicineIndex: -1,
        key: 100,
          dietGuidelinesColumns: [
              {
                  type: 'index',
                  width: 80,
                  align: 'center',
              },
              {
                  title: '食材',
                  align: 'center',
                  key: 'foodMaterialName',
                  ellipsis: true,
                  tooltip: true
              },
              {
                  title: '详情',
                  align: 'center',
                  ellipsis: true,
                  tooltip: true,
                  render: (h, params) => {
                      return h('div', [
                          h('Button', {
                              props: {
                                  type: 'primary',
                                  icon: 'ios-list-box',
                                  label: "small",
                              },
                              style: {
                                  marginRight: '5px'
                              },
                              on: {
                                  click: () => {
                                      this.infoItem_modal(params.row)
                                  }
                              }
                          }, '详情'),
                      ])
                  }
              }
          ],//食材表头
          columnsInfo: [
              {
                  type: 'index',
                  width: 80,
                  align: 'center',
              },
              {
                  title: '营养物质',
                  align: 'center',
                  ellipsis: true,
                  tooltip: true,
                  render: (h, params) => {
                      let item = this.infoItem.nutritionTypeList[params.index]
                      return h("span", item.name + '（' + item.forShort + '） - ' + item.englishName)
                  },
              },
              {
                  title: '含量',
                  align: 'center',
                  ellipsis: true,
                  tooltip: true,
                  render: (h, params) => {
                      let item = this.infoItem.nutritionTypeList[params.index]
                      return h("span", item.value + ' ' + item.unit)
                  },
              },
              {
                  title: '重点营养物质',
                  align: 'center',
                  ellipsis: true,
                  tooltip: true,
                  render: (h, params) => {
                      let item = this.infoItem.nutritionTypeList[params.index]
                      return h("span", item.isKey ? '是' : '')
                  },
              },
          ],
      }
    },
    created() {
      this.findAllDietGuidelinesList()
      this.findAllDietPlan()
      this.findAllNutritionalGoal()
      this.findAllMedicine()
    },
    methods: {
      saveUserDietlines() {
        if (this.prescription.dietGuidelinesDetail == null) {
          return
        }
        this.$http.post('dietGuidelines/addUser', {
          userId: this.user.id,
          detailIds: this.prescription.dietGuidelinesDetail.toString()
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
//            this.getAllEdibleFood()
              //获取患者的可食用/不可食用食材
              this.getUserFoods()
              this.getAllEdibleFood()
            this.stepsNum++
          } else {
            this.$Notice.error({title: '饮食原则绑定失败', desc: msg.message});
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      followDiagnose(value) {
        this.prescription.followDiagnose = value
      },
      medicineChange(index) {
        this.medicineVo.medicine = this.medicineList[index]
        console.log('medicine:', this.medicineVo)
      },
      delMedicine(index) {
        this.prescription.content.splice(index, 1)
      },
      // 获取饮食原则
      findAllDietGuidelinesList() {
        this.$http.post('dietGuidelines/list', {
          isDeleted: false,
          pageSize: 0,
          pageNum: 0,
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.dietGuidelinesAllList = msg.data
//              for (let i = 0; i < this.dietGuidelinesAllList.length; i ++) {
//                this.findFoodMaterailByGuidelines(this.dietGuidelinesAllList[i].id, i)
//              }
          } else {
            this.$Notice.error({title: '饮食原则查询失败', desc: msg.message});
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      //查询可食用食材
      getAllEdibleFood() {
        this.$http.post('drools/getAllEdibleFood', {
          user_id: this.user.id
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.foodMaterialAllList = msg.data
          } else {
            this.$Notice.error({title: '食材查询失败', desc: msg.message});
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      // 获取饮食原则下的食材
      // findFoodMaterailByGuidelines(id, i) {
      //   this.$http.post('dietGuidelines/listFood', {
      //     dietGuidelinesId: id
      //   }).then(function (res) {
      //     let msg = res.body
      //     if (msg.success) {
      //       console.log('guideLineFood:', msg.data, 'id:', id, 'i:', i)
      //       this.dietGuidelinesAllList[i].foodMaterialList = msg.data
      //     } else {
      //       this.$Notice.error({title: '饮食原则查询失败', desc: msg.message});
      //     }
      //   }, function (res) {
      //     this.myError(res.body)
      //   })
      // },
      // 获取食材食谱
      findAllDietPlan() {
        this.$http.post('dietPlan/listTemplate', {
          isDeleted: false,
          pageSize: 0,
          pageNum: 0,
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.dietPlanAllList = msg.data.list
          } else {
              if (msg.code === '201' || msg.message==='未登录') {
                  this.$Notice.error({title: '登录过期，请重新登录'});
                  this.$router.push('/')
              } else {
                  this.$Notice.error({title: '饮食计划模板查询失败', desc: msg.message});
              }
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      // 获取药品
      findAllMedicine() {
        this.$http.post('medicine/list', {
          isDeleted: false,
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.medicineList = msg.data.list
          } else {
              if (msg.code === '201' || msg.message==='未登录') {
                  this.$Notice.error({title: '登录过期，请重新登录'});
                  this.$router.push('/')
                  console.log('提示重新登录')
              } else {
                  this.$Notice.error({title: '药品查询失败', desc: msg.message});
              }
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      // 获取可食用食材
      // findUserAllFoodMaterial() {
      //   this.$http.post('foodMaterial/listUserFood', {
      //     userId: this.user.id
      //   }).then(function (res) {
      //     this.tableLoading = false
      //     let msg = res.body
      //     if (msg.success) {
      //       console.log('userFood:', msg.data.list)
      //       this.foodMaterialAllList = msg.data.list
      //     } else {
      //       this.$Notice.error({title: '食材查询失败', desc: msg.message});
      //     }
      //   }, function (res) {
      //     this.myError(res.body)
      //   })
      // },
      // 获取营养目标
      findAllNutritionalGoal() {
        this.$http.post('nutritionalGoal/listRequirement', {
          age: this.nutritionalGoalSearch.age ? this.nutritionalGoalSearch.age : null,
          sex: this.nutritionalGoalSearch.sex == 0 ? 'm' : 'f'
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.nutritionalGoal = msg.data
            if (msg.data.length === 1) {
              this.nutritionalGoal = msg.data[0]
            }
          } else {
            this.$Notice.error({title: '营养目标列表查询失败', desc: msg.message});
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      prevSteps() {
        if (this.stepsNum > 0) {
          this.stepsNum--
        }
      },
      nextSteps() {
        switch (this.stepsNum) {
          case 0:
              // 处方笺
              this.saveMedicineUsage()
              // this.stepsNum++
              break

          case 1:
              // 医嘱说明
              this.stepsNum++
              break
//            if (this.prescription.dietPlanId == null || this.prescription.dietPlanId == '') {
//              this.$Notice.warning({title: '请先制定食谱'})
//              return
//            }

          case 2:
              //饮食原则
              if (this.prescription.dietGuidelines == null || this.prescription.dietGuidelines.length <= 0) {
                  this.$Notice.warning({title: '请先选择饮食原则'})
                  return
              }
              // 先获取已选择原则的食材界限id
              let lineIds = []
              for (let item = 0; item < this.dietGuidelinesAllList.length; item ++) {
                  if (this.prescription.dietGuidelines.indexOf(this.dietGuidelinesAllList[item].id) >= 0) {
                      this.dietGuidelinesAllList[item].detailList.map(line => {
                          lineIds.push(line.id)
                      })
                  }
              }
              let tempIds = []
              this.prescription.dietGuidelinesDetail.map(item => {
                  if (lineIds.indexOf(item) >= 0) {
                      tempIds.push(item)
                  }
              })

              this.prescription.dietGuidelinesDetail = tempIds

              if (this.prescription.dietGuidelinesDetail == null || this.prescription.dietGuidelinesDetail.length != this.prescription.dietGuidelines.length) {
                  this.$Notice.warning({title: '请为患者配置饮食原则的禁食界限'})
                  return
              }
              this.saveUserDietlines()
              this.addItemInfo.dietPlan = {}
              break

          case 3:
              // 营养目标
              this.addNutritionalGoal()
              // this.stepsNum++
              break
          case 4:
              //食谱
              if (this.addItemInfo.dietPlan == null || this.addItemInfo.dietPlan == {}) {
                  this.$Notice.warning({title: '请先制定食谱'})
                  return
              }
              let flag = false
              let that = this
              Object.keys(this.addItemInfo.dietPlan).forEach(function (key) {
                  that.addItemInfo.dietPlan[key].forEach(function (TemplateInfo) {
                      if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0) {
                          flag = true
                          return
                      }
                  })
              })
              if (flag || this.addItemInfo.dietPlan.length <= 0) {
                  return this.$Message.warning('食谱存在空行，请完善或删除');
              }
              this.addDietPlan()
              // this.stepsNum++
              break
          case 5:
            // 其他设置
            if (this.prescription.followDiagnose) {
              this.saveOtherOrder()
            } else {
              this.savePrescription()
            }
            break
        }
      },
      // nutritionalGoalSelect(value) {
      //   for (let i in this.nutritionalGoalAllList) {
      //     if (this.nutritionalGoalAllList[i].id === value) {
      //       this.nutritionalGoalInfo = this.nutritionalGoalAllList[i].nutritionalGoalInfos
      //       return
      //     }
      //   }
      // },
      dietPlanSelect(value) {
        if (value == undefined) {
          return this.addItemInfo.infoList.length = 0
        }
        let obj = {}
        for (let i in this.dietPlanAllList) {
          let item = this.dietPlanAllList[i]
          if (item.id === value) {
            obj = item
            break
          }
        }
        let infoList = {}
        // obj.infoVOList.map((item) => {
        //   let list = []
        //   item.infoList.forEach((info) => {
        //     list.push({
        //       foodMaterialId: info.foodMaterialId,
        //       type: info.type,
        //       value: info.value,
        //       remark: info.remark,
        //       key: this.key++
        //     })
        //   })
        //   infoList[item.type] = list
        // })
        this.addItemInfo.dietPlan = infoList
      },
      addTemplateInfo(week) {
        if (this.addItemInfo.dietPlan[week] == null) {
          let diet = []
          diet.push({foodMaterialId: '', type: week, value: 0, unit: '', remark: '', key: this.key++})
          this.$set(this.addItemInfo.dietPlan, week, diet)
        } else {
          this.addItemInfo.dietPlan[week].push({
            foodMaterialId: '',
            type: week,
            value: 0,
            unit: '',
            remark: '',
            key: this.key++
          })
        }
        this.$forceUpdate()
      },
      removeTemplateInfo(key, index) {
        this.addItemInfo.dietPlan[key].splice(index, 1)
      },
      openMedicineModal() {
        this.medicineModal = true
        this.medicineVo = {
          medicalId: null,
          medicine: {},
          medicalName: '',
          specs: '25mg*10s*3板',
          once: {
            num: null,
            type: 'mg/次'
          },
          frequency: '每日一次',
          channel: '口服',
          dayNum: null,
          num: null,
          content: null,
        }
      },
      addMedical() {
        if (this.medicineVo.medicine == null || this.medicineVo.medicine.id == null) {
          this.$Notice.warning({title: '请选择药品/营养素'})
          return
        }
        this.medicineModal = false
        this.prescription.content.push(this.medicineVo)
      },
        cancelMedical(){
            this.medicineModal = false
        },
      // 新增食谱
      addDietPlan(){
        let infoList = []
        for (let i in this.addItemInfo.dietPlan) {
          infoList = infoList.concat(this.addItemInfo.dietPlan[i])
        }
        if (infoList.length === 0) {
          return this.$Message.warning('食谱不能为空')
        }
        this.$http.post('dietPlan/add',{
          userId:this.user.id,
          infoList:JSON.stringify(infoList)
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.prescription.dietPlanId = msg.data.id
            this.stepsNum++
          }else {
            this.$Notice.error({title:'食谱新增失败',desc: msg.message});
          }
        },function (res) {
          this.cancelItem()
          this.myError(res.body)
        })
      },
      // 新增饮食目标
      addNutritionalGoal(){
        this.$http.post('nutritionalGoal/add',{
          name:this.caseData.id,
          nutritionalGoalInfos:JSON.stringify(this.nutritionalGoal.infoList)
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.prescription.nutritionalGoalId = msg.data.id
            this.stepsNum++
          }else {
            this.$Notice.error({title:'营养目标新增失败',desc: msg.message});
          }
        },function (res) {
          this.myError(res.body)
        })
      },
      // 新增处方笺
      saveMedicineUsage () {
        let medicineUsage = {
          medicalRecordId : this.caseData.id,
          medicineUsageList: []
        }
        this.prescription.content.forEach((info)=> {
          medicineUsage.medicineUsageList.push({
            medicineId: info.medicine.id,
            usage: info.frequency + info.once.num + info.once.type,
            channel: info.channel,
            day: info.dayNum,
            medicineNum: info.num,
            remark: info.content
          })
        })
        this.$http.post('medicalRecord/updateMedicineUsage',
          medicineUsage,
        {emulateJSON:false}).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.stepsNum++
          }else {
            this.$Notice.error({title:'处方䇝保存失败',desc: msg.message});
          }
        },function (res) {
          this.myError(res.body)
        })
      },
      // 保存下次随诊时间
      saveOtherOrder () {
        let orderTime = new Date(new Date(this.prescription.followTime).getTime() - parseInt(this.prescription.remindTime) * 24 * 60 * 60 * 1000)
        this.$http.post('medicalRecord/addOrder', {
          userId: this.user.id,
          medicalRecordId: this.caseData.id,
          orderTime: orderTime.toString(),
          diagnoseTime: this.prescription.followTime.toString()
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.savePrescription()
          } else {
            this.$Notice.error({title: '下次随诊设置失败', desc: msg.message});
          }
        }, function (res) {
          this.myError(res.body)
        })
      },
      // 新增诊断处方
      savePrescription () {
        let p = {
          userId: this.user.id,
          medicalRecordId: this.caseData.id,
          dietPlanId: this.prescription.dietPlanId,
          nutritionalGoalId: this.prescription.nutritionalGoalId,
          doctorAdvice: this.prescription.advice
        }
        this.$http.post('prescription/add',p,{emulateJSON:false}).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.$Notice.success({title: '处方新增成功'});
            this.$router.push('/doctor_manage')
          }else {
            this.$Notice.error({title:'处方新增失败',desc: msg.message});
          }
        },function (res) {
          this.myError(res.body)
        })
      },
        // 获取患者的可食用/不可食用食材
        getUserFoods () {
          this.getUserEdibalFoods()
            this.getUserInedibleFoods()
        },
        //获取患者的可食用食材列表
        getUserEdibalFoods () {
            this.$http.post('drools/getAllEdibleFood',
                {
                    user_id:  this.user.id,
                    name: this.foodMaterial
                }
            ).then(function (res) {
                let msg = res.body
                console.log('msg_____', msg)
                if (msg.success) {
                    if (msg.data != null) {
                        this.edibalFoodList = msg.data
//                        this.foodMaterialAllList = msg.data
                    }
                } else {
                    this.$Notice.error({title: '查询失败', desc: msg.message});
                }
            }, function (res) {
                this.myError(res.body)
            })
        },

        // 获取患者的不可食用食材列表
        getUserInedibleFoods () {
            this.$http.post('drools/getAllInedibleFood',
                {
                    user_id:  this.user.id,
                    name: this.foodMaterial
                }
            ).then(function (res) {
                let msg = res.body
                console.log('msg_____', msg)
                if (msg.success) {
                    if (msg.data != null) {
                        this.inedibleFood = msg.data
                    }
                } else {
                    this.$Notice.error({title: '查询失败', desc: msg.message});
                }
            }, function (res) {
                this.myError(res.body)
            })
        },
        // 根据饮食原则获取可食用食材列表和不可食用食材列表
        getFoodsByDietGuidline (value) {
            // 先获取已选择原则的食材界限id
//            let lineIds = []
//            for (let item = 0; item < this.dietGuidelinesAllList.length; item ++) {
//                if (value.indexOf(this.dietGuidelinesAllList[item].id) >= 0) {
//                    this.dietGuidelinesAllList[item].detailList.map(line => {
//                        lineIds.push(line.id)
//                    })
//                }
//            }
//            console.log('id1111_____', lineIds)
//            this.prescription.dietGuidelinesDetail.map(item => {
//                if (lineIds.indexOf(item) < 0) {
//                    this.prescription.dietGuidelinesDetail.remove(item)
//                }
//            })

//            for (let item = 0; item < this.prescription.dietGuidelinesDetail.length; item ++){
//                if (lineIds.indexOf(item) < 0) {
//                    this.prescription.dietGuidelinesDetail.splice(item, 1)
//                }
//            }
//            console.log('lines_____', this.prescription.dietGuidelinesDetail)

          if (this.prescription.dietGuidelines == null || this.prescription.dietGuidelines.length <= 0) {
              return
          }
            this.$http.post('drools/getFood',
                {
                    ids: JSON.stringify(this.prescription.dietGuidelines),
                    foodMaterialName: this.foodMaterial
                }
            ).then(function (res) {
                let msg = res.body
                console.log('msg_____', msg)
                if (msg.success) {
                    if (msg.data != null) {
                        this.edibalFoodList = msg.data.edibalFoodList
                        this.inedibleFood = msg.data.inedible
                    }
                } else {
                    this.$Notice.error({title: '查询失败', desc: msg.message});
                }
            }, function (res) {
                this.myError(res.body)
            })
        },
        // 根据食材Id获取食材详情
        getFoodMaterialDetails (foodId) {
            this.$http.post('foodMaterial/detail2',
                {
                    foodMaterialId: foodId
                }
            ).then(function (res) {
                let msg = res.body
                console.log('msg_____', msg)
                if (msg.success) {
                    this.infoItem = msg.data
                } else {
                    this.$Notice.error({title: '获取详情失败', desc: msg.message});
                }
            }, function (res) {
                this.myError(res.body)
            })
        },
        infoItem_modal(item) {
            this.getFoodMaterialDetails(item.foodMaterialId)
            this.infoModel = true
        },
        cancelItem() {
            this.infoModel = false
        }
    }
  }
</script>

<style scoped>

</style>
